import { GetOrderListResponse } from 'src/sdk-servicing';
import { createAction, props } from '@ngrx/store';
import { asyncProps, FromApiActionPayload, WithRequestId, AsyncRequest } from '@lib/store';
import { GetOrderListModel } from './get-order-list.state';

/** StateDetailsActions */
const ACTION_SET = '[GetOrderList] set';
const ACTION_UPDATE = '[GetOrderList] update';
const ACTION_RESET = '[GetOrderList] reset';
const ACTION_FAIL = '[GetOrderList] fail';
const ACTION_CANCEL_REQUEST = '[GetOrderList] cancel request';

/** Async Actions */
const ACTION_SET_FROM_API = '[GetOrderList] set from api';
const ACTION_UPDATE_FROM_API = '[GetOrderList] update from api';

/**
 * Clear the current store object and replace it with the new one,
 * update isFailure to false, and update isPending with the boolean given as parameter if defined
 */
export const setGetOrderList = createAction(ACTION_SET, props<WithRequestId<GetOrderListModel>>());

/**
 * Change a part or the whole object in the store and update isFailure to false. The pendingUpdate boolean,
 * if set to true or false, will update the isPending property from the StateDetails
 */
export const updateGetOrderList = createAction(ACTION_UPDATE, props<WithRequestId<Partial<GetOrderListModel>>>());

/**
 * Clear the whole state, return to the initial one
 */
export const resetGetOrderList = createAction(ACTION_RESET);

/** Action to cancel a Request ID registered in the store. Can happen from effect based on a switchMap for instance */
export const cancelGetOrderListRequest = createAction(ACTION_CANCEL_REQUEST, props<AsyncRequest>());

/**
 * Update isPending from the StateDetails to false, and isFailure to true
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const failGetOrderList = createAction(ACTION_FAIL, props<WithRequestId<{ error: any }>>());

/**
 * Update isPending to true, triggers setFromApi Effect
 */
export const setGetOrderListFromApi = createAction(
  ACTION_SET_FROM_API,
  asyncProps<FromApiActionPayload<GetOrderListResponse>>()
);

/**
 * Update isPending to true, triggers updateFromApi Effect
 */
export const updateGetOrderListFromApi = createAction(
  ACTION_UPDATE_FROM_API,
  asyncProps<FromApiActionPayload<GetOrderListResponse>>()
);
